import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { WorkflowQueryAction, WorkflowQuerySnapshot } from "./model.ts";
export interface WorkflowQuerySession { readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<WorkflowQuerySnapshot>>; readonly dispatch: (action: WorkflowQueryAction) => Effect.Effect<void> }
export class WorkflowSessions extends Context.Service<WorkflowSessions, { readonly open: Effect.Effect<WorkflowQuerySession, never, Scope.Scope> }>()("workerstation/frontend/WorkflowSessions") {}
